var _rect, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultancyService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Startup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Startup",
    className: "",
    fillOpacity: 1,
    fill: "#3d43ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,25a5,5,0,1,0-5-5A5,5,0,0,0,32,25Zm0-8a3,3,0,1,1-3,3A3,3,0,0,1,32,17Z",
    id: "svg_1",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,54H60V18a4,4,0,0,0-4-4H40A17.69,17.69,0,0,0,32.58.19a1,1,0,0,0-1.16,0A17.69,17.69,0,0,0,24,14H8a4,4,0,0,0-4,4V54H3a3,3,0,0,0-3,3v2a5,5,0,0,0,5,5H59a5,5,0,0,0,5-5V57A3,3,0,0,0,61,54ZM10,20H20.67C16.06,23.46,16,23.33,16,24v3a1,1,0,0,0,1,1h7.18a3,3,0,0,0,2,1.87L27,33.24A1,1,0,0,0,28,34v7.28a4.37,4.37,0,0,0-4.47.87,6,6,0,0,0-9.45,3.94,5,5,0,0,0-4,3.91C10,50,10,52.3,10,20Zm14,6H18V24.5L24,20Zm11.22,6H29c-.3,0-.15.28-.72-2h7.44ZM15,48a1,1,0,0,0,1-1,4,4,0,0,1,6.35-3.23C21,47.07,24,47,24,45.5a2.5,2.5,0,0,1,5,0,1,1,0,0,0,2,0,4.42,4.42,0,0,0-1-2.79V34h4v8.71C32.94,44,32.42,46.5,34,46.5a1,1,0,0,0,1-1,2.5,2.5,0,0,1,5,0c0,1.52,3,1.58,1.65-1.73A4,4,0,0,1,48,47a1,1,0,0,0,1,1,3,3,0,0,1,2.82,2H12.18A3,3,0,0,1,15,48Zm38.9,2a5,5,0,0,0-4-3.91,6,6,0,0,0-9.45-3.94A4.36,4.36,0,0,0,36,41.28V34a1,1,0,0,0,1-.76l.84-3.37a3,3,0,0,0,2-1.87H47a1,1,0,0,0,1-1V24c0-.67,0-.52-4.67-4H54C54,52.3,54.06,50,53.9,50ZM40,20l6,4.5V26H40ZM34.9,5.25a6,6,0,0,1-5.8,0,16.56,16.56,0,0,1,2.9-3A16.68,16.68,0,0,1,34.9,5.25ZM28,6.92a7.85,7.85,0,0,0,8,0c2.59,4.59,2,7.41,2,20.08a1,1,0,0,1-1,1H27a1,1,0,0,1-1-1C26,14.18,25.47,11.44,28,6.92ZM6,18a2,2,0,0,1,2-2H24c0,2.6,1.73,2-15,2a1,1,0,0,0-1,1V51a1,1,0,0,0,1,1H55a1,1,0,0,0,1-1V19a1,1,0,0,0-1-1c-16.67,0-15,.66-15-2H56a2,2,0,0,1,2,2V54H6ZM40.13,56l-.67,1H24.54l-.67-1ZM62,59a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V57a1,1,0,0,1,1-1H21.46l1.71,2.55c.42.64-.45.45,16.83.45.69,0,.74-.31,2.54-3H61a1,1,0,0,1,1,1Z",
    id: "svg_2",
    fill: "#3d43ac"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancyService);
export default __webpack_public_path__ + "static/media/consultancy-service.587928b52826ec3aa415b81572d7ec8e.svg";
export { ForwardRef as ReactComponent };